// components/pricing/SingleSessionPricing/index.jsx
import React, { useState } from "react";
import { Check } from "lucide-react";
import { Button } from "../../../styles/components";
import { formatCurrency } from "../../../utils/format";
import {
	PackageGrid,
	PackageCard,
	PackageHeader,
	Price,
	FeatureList,
	Feature,
	PackageType,
} from "./styles";
import { SingleSessionBookingModal } from "./SingleSessionBookingModal";

const singleSessionPackages = [
	{
		id: "basic-single",
		name: "Basic Session",
		price: 9900,
		duration: 1,
		photoCount: 15,
		type: "regular",
		features: [
			"1-hour photo session",
			"15 edited digital photos",
			"Online gallery access",
			"Basic props included",
			"1 outfit change",
		],
	},
	{
		id: "premium-single",
		name: "Premium Session",
		price: 17900,
		duration: 2,
		photoCount: 35,
		type: "regular",
		features: [
			"2-hour photo session",
			"35 edited digital photos",
			"Online gallery access",
			"Premium props included",
			"2 outfit changes",
			"Location of your choice",
		],
	},
	{
		id: "newborn-special",
		name: "Newborn Special",
		price: 27900,
		duration: 3,
		photoCount: 50,
		type: "newborn",
		features: [
			"3-hour newborn session",
			"50 edited digital photos",
			"Online gallery access",
			"Specialized newborn props",
			"Multiple setups",
			"Parent & family shots included",
			"Flexible timing for feeding breaks",
		],
	},
];

const SingleSessionPricing = () => {
	const [showModal, setShowModal] = useState(false);
	const [selectedPackage, setSelectedPackage] = useState(null);

	const handleBookSession = (pkg) => {
		setSelectedPackage(pkg);
		setShowModal(true);
	};

	return (
		<>
			<PackageGrid>
				{singleSessionPackages.map((pkg) => (
					<PackageCard key={pkg.id}>
						<PackageHeader>
							<h3>{pkg.name}</h3>
							<PackageType type={pkg.type}>
								{pkg.type === "newborn" ? "Newborn Special" : "Regular Session"}
							</PackageType>
							<Price>
								<span className="currency">Rs</span>
								<span className="amount">
									{formatCurrency(pkg.price).replace("Rs", "")}
								</span>
							</Price>
							<p className="duration">
								{pkg.duration} hour{pkg.duration > 1 ? "s" : ""}
							</p>
						</PackageHeader>

						<FeatureList>
							{pkg.features.map((feature, index) => (
								<Feature key={index}>
									<Check size={18} />
									{feature}
								</Feature>
							))}
						</FeatureList>

						<Button onClick={() => handleBookSession(pkg)} size="large">
							Book Now
						</Button>
					</PackageCard>
				))}
			</PackageGrid>

			{showModal && selectedPackage && (
				<SingleSessionBookingModal
					packageDetails={selectedPackage}
					onClose={() => setShowModal(false)}
				/>
			)}
		</>
	);
};

export default SingleSessionPricing;
